import { render, staticRenderFns } from "./OverviewWallet.vue?vue&type=template&id=531649b8&lang=pug&"
import script from "./OverviewWallet.vue?vue&type=script&lang=ts&"
export * from "./OverviewWallet.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewWallet.vue?vue&type=style&index=0&id=531649b8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports